import { InjectionToken, inject } from '@angular/core';
import { IChannelProviderStore } from './channel-provider.public';
import { ChannelProviderStore } from './channel-provider.store';

export const CHANNELPROVIDER_STORE = new InjectionToken<IChannelProviderStore>(
    'CHANNELPROVIDER_STORE',
    {
        providedIn: 'root',
        factory: () => inject(ChannelProviderStore) as IChannelProviderStore,
    },
);
